var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import styles from '../../@patternfly/patternfly-next/components/Progress/progress.css.js';
import { css, getModifier } from '@patternfly/react-styles';
import PropTypes from 'prop-types';
import ProgressContainer, { ProgressMeasureLocation, ProgressVariant } from './ProgressContainer';
import { getUniqueId } from '../../internal/util';

export var ProgressSize = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};

var propTypes = {
  /** Classname for progress component. */
  className: PropTypes.string,
  /** Size variant of progress. */
  size: PropTypes.oneOf(Object.values(ProgressSize)),
  /** Where the measure percent will be located. */
  measureLocation: PropTypes.oneOf(Object.values(ProgressMeasureLocation)),
  /** Status variant of progress. */
  variant: PropTypes.oneOf(Object.values(ProgressVariant)),
  /** Title above progress. */
  title: PropTypes.string,
  /** Label to indicate what progress is showing. */
  label: PropTypes.node,
  /** Actual value of progress. */
  value: PropTypes.number,
  /** DOM id for progress component. */
  id: PropTypes.string,
  /** Minimal value of progress. */
  min: PropTypes.number,
  /** Maximum value of progress. */
  max: PropTypes.number,
  /** Dynamic description of progress. */
  valueText: PropTypes.string
};

var defaultProps = {
  className: '',
  measureLocation: ProgressMeasureLocation.top,
  variant: ProgressVariant.info,
  id: '',
  title: '',
  min: 0,
  max: 100,
  size: null,
  value: 0,
  valueText: null
};

var Progress = function (_Component) {
  _inherits(Progress, _Component);

  function Progress() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Progress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Progress.__proto__ || Object.getPrototypeOf(Progress)).call.apply(_ref, [this].concat(args))), _this), _this.id = _this.props.id || getUniqueId(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Progress, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          size = _props.size,
          value = _props.value,
          title = _props.title,
          label = _props.label,
          variant = _props.variant,
          measureLocation = _props.measureLocation,
          min = _props.min,
          max = _props.max,
          valueText = _props.valueText,
          props = _objectWithoutProperties(_props, ['id', 'className', 'size', 'value', 'title', 'label', 'variant', 'measureLocation', 'min', 'max', 'valueText']);

      var additionalProps = _extends({}, props, valueText ? { 'aria-valuetext': valueText } : { 'aria-describedby': this.id + '-description' });
      var limitedValue = void 0;
      limitedValue = value < min ? min : value;
      limitedValue = limitedValue > max ? max : limitedValue;
      return React.createElement(
        'div',
        _extends({}, additionalProps, {
          className: css(styles.progress, getModifier(styles, variant, ''), getModifier(styles, measureLocation, ''), getModifier(styles, measureLocation === ProgressMeasureLocation.inside ? ProgressSize.lg : size, ''), className),
          id: this.id,
          role: 'progressbar',
          'aria-valuemin': min,
          'aria-valuenow': limitedValue,
          'aria-valuemax': max
        }),
        React.createElement(ProgressContainer, {
          parentId: this.id,
          value: limitedValue,
          title: title,
          label: label,
          variant: variant,
          measureLocation: measureLocation
        })
      );
    }
  }]);

  return Progress;
}(Component);

Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;

export default Progress;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Progress/Progress.js
// module id = 274
// module chunks = 0